'use client';
import React, { useState } from 'react';
import './Button.scss';
import cn from 'classnames';

export default function Button({
  variant = 'primary',
  className,
  isShowTooltip = true,
  onClick,
  children,
  target,
  ...props
}) {
  const [hoverPosition, setHoverPosition] = useState(null);
  const [isRippleActive, setRippleActive] = useState(false);

  const handleMouseMove = (event) => {
    const rect = event.currentTarget.getBoundingClientRect();
    setHoverPosition({
      x: event.clientX - rect.left,
      y: event.clientY - rect.top,
    });
  };

  const handleMouseLeave = () => {
    setHoverPosition(null);
  };

  const handleButtonClick = () => {
    if (isRippleActive) {
      setRippleActive(false);
    }
    setRippleActive(true);
    setTimeout(() => setRippleActive(false), 500);

    if (target) {
      window.open(target, '_blank');
      return;
    }

    onClick?.();
  };

  return (
    <div className={'button-content-block'}>
      <div className={'container-button'}>
        <button
          className={cn('button', variant, className)}
          onMouseMove={handleMouseMove}
          onMouseLeave={handleMouseLeave}
          onClick={handleButtonClick}
          data-tooltip-id={isShowTooltip ? 'my-tooltip-3' : ''}
          {...props}
        >
          {hoverPosition && (
            <span
              className={cn('circle', variant, isRippleActive && 'ripple')}
              style={{
                left: `${hoverPosition.x}px`,
                top: `${hoverPosition.y}px`,
              }}
            ></span>
          )}
          <span className={'text'}>{children}</span>
        </button>
      </div>
    </div>
  );
}
